/**
 * @fileoverview POST handler for the "/data_objects/object_relationship_types/:rel_type_id/fields" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsObjectRelationshipTypeFieldsCacheKeys } from "./constants";
import type {
  PostCustomObjectsObjectRelationshipTypeFieldsProps,
  PostCustomObjectsObjectRelationshipTypeFieldsResult,
} from "./types";

export const postCustomObjectsObjectRelationshipTypeFields = reactQueryMutationAdapter(
  customObjectsObjectRelationshipTypeFieldsCacheKeys,
  ({
    appGroupId,
    relTypeId,
    name,
    data_type,
    display_label,
    required,
  }: PostCustomObjectsObjectRelationshipTypeFieldsProps): Promise<PostCustomObjectsObjectRelationshipTypeFieldsResult> => {
    return fetch<PostCustomObjectsObjectRelationshipTypeFieldsResult>(
      `/data_objects/object_relationship_types/${encodeURIComponent(relTypeId)}/fields`,
      "POST",
      {
        app_group_id: appGroupId,
        name,
        data_type,
        display_label,
        required,
      },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
